<div class="ui fluid container">
  <div class="ui borderless large menu">
    <a [routerLink]="['/']" class="logo item">
      <img src="/assets/images/docorga-white.png" class="ui logo" />
    </a>
    <div class="right menu">
      <div class="item" *ngIf="!isAuthenticated">
        <a class="ui blue button"href="/mySpace"> Connexion </a>
      </div>
      <div class="item desktopOnly" *ngIf="!isAuthenticated">
        <a class="ui very-basic button" (click)="register()"> Créer un compte </a>
      </div>


      <div class="ui item" style="margin-right: 1em;">
        <a [href]=" 'HELP_PATIENT' | linkVariable" target="_blank">
          <span class="ellipsis" style="color: white;" title="Accéder à la documentation en ligne, tutoriels vidéo ...">Besoin d'aide ?</span>
        </a>
      </div>
      <div class="ui dropdown item" fuiDropdown *ngIf="isAuthenticated">
        <span data-test="myAccount" class="ellipsis">Mon compte</span>  
        <i class="dropdown icon"></i>
        <div class="menu" fuiDropdownMenu>
          <a *ngIf="isCompleted" [routerLink]="['/mySpace']" routerLinkActive="active" class="item">
            <i class="home icon"></i>
            Mon espace
          </a>
          <a *ngIf="isCompleted" [routerLink]="['/mySpace/account/settings']" routerLinkActive="active" class="item">
            <i class="cog icon"></i>
            Paramètres
          </a>
          <div *ngIf="isCompleted" class="divider"></div>
          <a class="item" (click)="logout()">
            <i class="power off icon"></i>
            Déconnexion
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
